var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-postulacion justify-center shadow z-1"},[_c('img',{staticClass:"obj-cover",staticStyle:{"max-width":"180px","height":"40px"},attrs:{"src":_vm.$config.logo_blanco}})])
}
var staticRenderFns = []

export { render, staticRenderFns }